import {ConnectContactResponse, ConnectContactSmsEvent} from '@/api/dto/connect';
import ExpandMoreButton from '@common/timeline/ExpandMoreButton';
import AwsCommunicationsContactSmsEvent
  from '@/components/pages/tasks/aws_communications/contact/AwsCommunicationsContactSmsEvent';
import {SmsCollection} from '@/components/pages/tasks/aws_communications/contact/AwsCommunicationsContactSms.styles';

type Props = {
  connectContact: ConnectContactResponse;
}

export default function AwsCommunicationsContactSms({ connectContact }: Props) {
  if (!connectContact.smsData?.length) {
    return null;
  }

  return (
    <SmsCollection>
      {connectContact.smsData.slice(0, 1).map((event: ConnectContactSmsEvent) => (
        <AwsCommunicationsContactSmsEvent key={event.timestamp} event={event} />
      ))}
      {connectContact.smsData.length > 1 && (
        <ExpandMoreButton
          buttonText={`${connectContact.smsData.length - 1} more`}
          expandItems={[connectContact.smsData?.slice(1).map((event: ConnectContactSmsEvent) => (
            <AwsCommunicationsContactSmsEvent key={event.timestamp} event={event} />
          ))]}
          useExpandHideText
          active
        />
      )}
    </SmsCollection>
  );
}
